import React, { Component } from 'react';
import { Tab, Tabs } from 'material-ui/Tabs';
import FontIcon from 'material-ui/FontIcon';

import { base64Decode } from '../../../../actions/utilAction';
import PatientInfo from '../../patient_info';
import BehaviorGraphContainer from './BehaviourGraph/index';
import SkillAquisitionGraphContainer from './SkillAcuisitionGraph/index';

export default class Data extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientId: props.match.params.id ? base64Decode(props.match.params.id) : 0,
            activeTab: 0,
            activeTabValue: '0',
        }
    }

    setActive = (value) => {
        this.setState({ activeTab: value, activeTabValue: value });
    }

    render() {
        var styles = {
            default_tab: {
                height: '50px',
                fontSize: '13px',
            },
            active_tab: {
                color: '#fff',
                backgroundColor: 'rgba(0, 0, 0, 0.10)',
                height: '48px',
                fontSize: '13px',
            },
        };
        styles.tab = [];
        styles.tab[0] = styles.default_tab;
        styles.tab[1] = styles.default_tab;
        styles.tab[2] = styles.default_tab;
        styles.tab[3] = styles.default_tab;
        styles.tab[4] = styles.default_tab;
        styles.tab[5] = styles.default_tab;
        styles.tab[this.state.activeTab] = styles.active_tab;
        styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);
        return (
            <div>
                <h2 className="page_title">Bulk Data Collection Graphs</h2>
                <PatientInfo patientId={this.state.patientId} />
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <Tabs className="custom_tabs" value={this.state.activeTabValue} >
                            <Tab
                                onClick={(e) => this.setActive('0')}
                                style={styles.tab[0]}
                                value="0"
                                className="customtab"
                                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                label={<font>Skill Acquisition Graph</font>}>
                                {
                                    this.state.activeTabValue === '0' ?
                                       <SkillAquisitionGraphContainer 
                                        patientId={this.state.patientId}
                                       />
                                        : ''
                                }
                            </Tab>
                            <Tab
                                onClick={(e) => this.setActive('1')}
                                style={styles.tab[1]}
                                value="1"
                                className="customtab"
                                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                label={<font>Behavior Graph</font>}>
                                {
                                    this.state.activeTabValue === '1' ?
                                       <BehaviorGraphContainer 
                                        patientId={this.state.patientId}
                                       />
                                        : ''
                                }
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionBatchGraph/index.js